import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

const LoadingSkeleton = ({count, style}) => {

  return (
    // <SkeletonTheme baseColor="#202020" highlightColor="#444">
      // <p>
        <Skeleton count={count} style={style} />
      // </p>
    // </SkeletonTheme>
  )
};

export default LoadingSkeleton;
